import Card from 'Components/ContractGenerator/layouts/Card';
import Extension from 'Components/ContractGenerator/layouts/Extension';
import Section from 'Components/ContractGenerator/layouts/Section';
import SelectedProduct from 'Components/ContractGenerator/layouts/SelectedProduct';
import Table from 'Components/ContractGenerator/layouts/Table';
import Constants from 'Components/ContractGenerator/shared/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Paragraph } from 'ViatoUi/Shared/Typo';

const Selection = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation(['contractGenerator', 'translation']);

	const { selectedExtensions, selectedRooms, selectedPaymentType, selectedContractTermInMonths, selectedAccommodationType } = useSelector(
		contractGeneratorSelectors.getDataToSubmit
	);

	const { ACCOMMODATION_TYPES } = useSelector(contractGeneratorSelectors.getConstants);
	const extensions = useSelector(contractGeneratorSelectors.getExtensions);
	const blockedFields = useSelector(contractGeneratorSelectors.getBlockedFields);
	const blockedExtensions = blockedFields?.selectedExtensions?.ids || [];
	const buttonIsDisabled = blockedFields?.selectedRooms && blockedFields?.selectedContractTermInMonths && blockedFields?.selectedProduct;
	const contractTermText =
		selectedContractTermInMonths !== 0
			? `${selectedContractTermInMonths} ${t('pages.step3.selection.months')}`
			: t('pages.step3.selection.monthlyCancelable');

	const getExtensionOption = extension => {
		return extension.options[selectedExtensions.options[extension.id] || extension.selectedOption];
	};

	return (
		<Section headline={t('pages.step3.selection.headline')} darkened lastElementOfStep>
			<Card
				buttonSettings={{
					type: 'dark',
					text: t('app.userActions.change'),
					onClick: () =>
						dispatch(
							contractGeneratorOperations.setActiveStep(
								Constants.STEPS.STEP1,
								'viato-contract-generator-contract-settings',
								true
							)
						)
				}}
				hasButton={!buttonIsDisabled}
				headline={t('pages.step3.selection.contractData')}
			>
				<Table
					fields={[
						{
							label: t('pages.step3.selection.amountRooms', {
								unit: t(`translation:${ACCOMMODATION_TYPES[selectedAccommodationType].UNIT_TRANSLATION_PATH}.plural`)
							}),
							value: selectedRooms
						},
						{
							label: t('pages.step3.selection.contractTerm'),
							value: contractTermText
						},
						{ label: t('pages.step3.selection.paymentType'), value: t(`pages.step3.selection.${selectedPaymentType}`) }
					]}
				/>
			</Card>
			<Spacer height='l' />
			<SelectedProduct
				buttonSettings={{
					type: 'dark',
					text: t('app.userActions.change'),
					onClick: () =>
						dispatch(
							contractGeneratorOperations.setActiveStep(
								Constants.STEPS.STEP1,
								'viato-contract-generator-product-selection',
								true
							)
						)
				}}
				hasButton={!buttonIsDisabled}
			/>
			<Spacer height='l' />

			{selectedExtensions.ids.map(extensionId => (
				<Extension
					key={extensionId}
					additionalDescriptions={extensions[extensionId].additionalDescriptions || []}
					buttonSettings={{
						type: 'dark',
						text: t('app.userActions.change'),
						onClick: () =>
							dispatch(
								contractGeneratorOperations.setActiveStep(
									Constants.STEPS.STEP2,
									`viato-contract-generator-extension-${extensionId}`,
									true
								)
							)
					}}
					extensionDiscountType={getExtensionOption(extensions[extensionId]).discount.type}
					extensionDiscountValue={getExtensionOption(extensions[extensionId]).discount.value}
					extensionOption={getExtensionOption(extensions[extensionId])}
					feeDiscountType={getExtensionOption(extensions[extensionId]).setupFee.discount.type}
					feeDiscountValue={getExtensionOption(extensions[extensionId]).setupFee.discount.value}
					hasButton={!blockedExtensions.includes(String(extensionId))}
					id={extensionId}
					infoComponents={extensions[extensionId].infoComponents || []}
					isSinglePayment={getExtensionOption(extensions[extensionId]).isSinglePayment}
					selectableExtensionOptions={extensions[extensionId].selectableExtensionOptions || []}
					translationKey={extensions[extensionId].key}
					isSummary
				/>
			))}
			<Spacer height='xl' />
			<Paragraph color='silver' font='normal' centered>
				{t('app.taxInfo')}
			</Paragraph>
			<Spacer height='xxl' />
			<Spacer height='xxl' />
		</Section>
	);
};

export default Selection;
